<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span epub:type="pagebreak" id="pg_vii" title="vii"><span class="ePub-I">Wisdom begins in wonder.</span></span></p>
<p class="FM-Epigraph-Source-fmeps">—S<span class="ePub-SC">OCRATES,</span> probably</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?61256518